import useSetTransactions from '../hooks/useSetTransactions'
import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import useGetInitBoxPaymentOs from '../../../../pages/easyPay/initMoneyPool/hooks/useGetInitBoxPaymentOs'
interface IFooterProps {
    total: number
    commission: number
    ctx_id: number
    ctx_type: string
    destination: string
    gateway: number | string
    isSelected: ISelectedBank
    Amount?: number
    isWallet?: boolean
}
interface ISelectedBank {
    saderat: boolean
    parsian: boolean
}
export default function Footer({
    total,
    commission,
    ctx_id,
    ctx_type,
    destination,
    gateway,
    isSelected,
    isWallet,
    Amount,
}: IFooterProps) {
    const { mutate } = useSetTransactions()
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data } = useGetInitBoxPaymentOs(profile?.id)
    const { state } = useLocation()
    const navigate = useNavigate()

    return (
        <div className=" w-full">
            <div
                className=" mx-8 rounded-3xl  bg-green-1 text-white text-center py-3 my-2 cursor-pointer"
                onClick={() => {
                    if (data) {
                        if (isSelected.saderat || isSelected.parsian) {
                            if (Amount) {
                                mutate({
                                    amount: Number(Amount),
                                    ctx_id: ctx_id,
                                    ctx_type: ctx_type,
                                    destination: destination,
                                    gateway: gateway,
                                    is_group_pay: false,
                                    payer_name: '',
                                    receiver: ctx_id,
                                    receiver_name: '',
                                    source: 'gtw',
                                    state: '',
                                    state_time: '',
                                    transaction_code: '',
                                })
                            } else {
                                localStorage.setItem(
                                    'toBePaidTransactions',
                                    JSON.stringify({
                                        type: 'group-all-payment',
                                        data: state.toBePaidTransactions,
                                        //@ts-ignore
                                        pk: null,
                                        //@ts-ignore
                                        gateway: null,
                                    })
                                )
                                navigate('/group-all-payment')
                            }
                        } else {
                            toast.error('نوع درگاه پرداخت را انتخاب کنید')
                        }
                    }
                }}
            >
                پرداخت
            </div>
        </div>
    )
}
